<div class="filter-for-list">

  <div [ngClass]="batchImportsAvailable ? 'multiple-buttons-cont' : ''">
    <app-device-crud [deviceId]="null" [mode]="CRUD_MODE.create" [deviceType]="deviceTypes"
                     [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>
    <app-device-batch-import *ngIf="batchImportsAvailable"></app-device-batch-import>
    <app-device-finder *ngIf="batchImportsAvailable"></app-device-finder>
  </div>
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput value="{{filter}}" (keyup)="applyFilter($event.target.value)"
           [placeholder]="'SEARCH' | translate">
  </mat-form-field>

  <div style="float:left">
    <mat-slide-toggle class="sliderActiveList" (change)="reLoadList()" ngModel="activeDevice" placement="right"
                      [ngbTooltip]="'DEVICE_ACTIVE_SLIDER_TOOLTIP' | translate">{{getTextForSlider(2)}}
    </mat-slide-toggle>
    <br clear="left"/>
    <mat-slide-toggle class="sliderActiveList" (change)="availableReloadList()" ngModel="availableDevice"
                      placement="right"
                      [ngbTooltip]="'AVAILABLE_TOOLTIP' | translate">{{ getTextForSlider(3)}}
    </mat-slide-toggle>
    <br *ngIf="batchImportsAvailable" clear="left"/>
    <mat-slide-toggle *ngIf="batchImportsAvailable" class="sliderActiveList" (change)="reLoadListAllLevel()"
                      placement="right"
                      [ngbTooltip]="'ALL_LEVEL_TOOLTIP' | translate">{{ getTextForSlider(1)}}
    </mat-slide-toggle>
  </div>
  <app-device-type-selector [widthInPercent]="70" [deviceTypeSelected]="deviceTypeSelected"
                            (deviceTypeChanged)="getListDevices($event)"></app-device-type-selector>
  <br clear="both"/>
</div>

<app-progressbar *ngIf="showSpinner===true"></app-progressbar>


<table mat-table [dataSource]="matTableDataSource" matSort class="table-striped" style="width:100%">
  <ng-container matColumnDef="selector">
    <th mat-header-cell *matHeaderCellDef>
      <app-progressbar *ngIf="showSpinner"></app-progressbar>
      <mat-chip-list *ngIf="showSpinner===false && availableDevice===true">
        <mat-chip [matBadge]="getCountSelectedDevices()" style="cursor:pointer" (click)="openModalForDevicesBatchAction()"
                  placement="right"
                  [ngbTooltip]="'MOVE_DEVICE_TOOLTIP' | translate">
          <fa-icon [icon]="iconService.faShoppingCart"></fa-icon>
        </mat-chip>
      </mat-chip-list>
    </th>
    <td mat-cell *matCellDef="let device">

      <mat-checkbox *ngIf="!device.parent" [(ngModel)]="device.selector" [value]="device.selector"></mat-checkbox>
      <fa-icon *ngIf="device.parent" style="color:red" [icon]="iconService.faExclamationTriangle"></fa-icon>
    </td>
  </ng-container>
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let device"> {{device.id}}</td>
  </ng-container>
  <ng-container matColumnDef="device_type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'TYPE'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <mat-chip>{{device.device_type|translate}}
      </mat-chip>

    </td>
  </ng-container>
  <ng-container matColumnDef="level_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LEVEL'|translate}}</th>
    <td mat-cell *matCellDef="let device" > {{device.level_name}}</td>
  </ng-container>
  <ng-container matColumnDef="location_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'LOCATION'|translate}}</th>
    <td mat-cell *matCellDef="let device" (click)="filterListWith(device.location_name)">{{device.location_name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="project_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'PROJECT'|translate}}</th>
    <td mat-cell *matCellDef="let device" (click)="filterListWith(device.project_name)"> {{device.project_name}}
    </td>
  </ng-container>
  <ng-container matColumnDef="uid">
    <th mat-header-cell *matHeaderCellDef>{{'DEVICE'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <span *ngIf="device?.parent?.parent" style="display: inline-block">
                 <mat-chip-list style="display: inline-block">
                        <mat-chip (click)="filterListWith(device.parent.parent.uid)" matBadgePosition="below after"
                                  matBadgeColor="accent"
                                  [matBadge]="device.parent.parent.channel">{{device.parent.parent.device_type.type|translate}}
                                                    </mat-chip>
                    </mat-chip-list>
                   <app-device-crud [deviceId]="device.parent.parent.id" [mode]="CRUD_MODE.read"
                                    [displayLink]="device.parent.parent.uid" [deviceType]="deviceTypes"
                                    [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>
                        <mat-icon class="arrow-parent">play_arrow
            </mat-icon>
            </span>
      <span *ngIf="device?.parent" style="display: inline-block">
                 <mat-chip-list style="display: inline-block">
                        <mat-chip (click)="filterListWith(device.parent.uid)" matBadgePosition="below after"
                                  matBadgeColor="accent"
                                  [matBadge]="device.parent.channel">{{device.parent.device_type.type|translate}}
                                                    </mat-chip>
                    </mat-chip-list>
                    <app-device-crud [deviceId]="device.parent.id" [mode]="CRUD_MODE.read"
                                     [displayLink]="device.parent.uid" [deviceType]="deviceTypes"
                                     [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>
            <mat-icon class="arrow-parent">play_arrow
            </mat-icon>
            </span>

      <mat-chip-list style="display:inline-block;">
        <mat-chip matBadgePosition="below after" matBadgeColor="accent"
                  [matBadge]="device.channel"
                  [removable]="true">
          <span>{{device.device_type|translate}}</span>
          <span class="inner-badge" *ngIf="device.unit">{{device.unit.value|translate}}</span>
          <span class="inner-badge-length" *ngIf="device.length">{{device.length}}m</span>
        </mat-chip>

      </mat-chip-list>
      <span class="linkInListPrincipal">{{device.uid}}</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="children_device">
    <th mat-header-cell *matHeaderCellDef>{{'CHILDREN_DEVICE'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      {{device.children_device.length === 0 ? '-' : ''}}

      <span *ngIf="device.children_device.length>0">

            <span *ngFor="let child of device.children_device">
            <app-device-crud *ngIf="child.device_type.id === 2" [deviceId]="child.id" [mode]="CRUD_MODE.read"
                             [deviceType]="deviceTypes" [unitList]="unitList"
                             [children_device]="child" (deviceLoading)="showSpinner = $event"></app-device-crud></span>

            <span *ngFor="let child of device.children_device">
            <app-device-crud *ngIf="child.device_type.id === 3" [deviceId]="child.id" [mode]="CRUD_MODE.read"
                             [deviceType]="deviceTypes" [unitList]="unitList"
                             [children_device]="child" (deviceLoading)="showSpinner = $event"></app-device-crud></span>

            <span *ngFor="let child of device.children_device">
            <app-device-crud *ngIf="child.device_type.id === 4" [deviceId]="child.id" [mode]="CRUD_MODE.read"
                             [deviceType]="deviceTypes" [unitList]="unitList"
                             [children_device]="child" (deviceLoading)="showSpinner = $event"></app-device-crud></span>

            <span *ngFor="let child of device.children_device">
            <app-device-crud *ngIf="child.device_type.id === 12" [deviceId]="child.id" [mode]="CRUD_MODE.read"
                             [deviceType]="deviceTypes" [unitList]="unitList"
                             [children_device]="child" (deviceLoading)="showSpinner = $event"></app-device-crud></span>
            <span *ngFor="let child of device.children_device">
            <app-device-crud *ngIf="child.device_type.id === 16" [deviceId]="child.id" [mode]="CRUD_MODE.read"
                             [deviceType]="deviceTypes" [unitList]="unitList"
                             [children_device]="child" (deviceLoading)="showSpinner = $event"></app-device-crud></span>

            </span>
    </td>
  </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef width="130px">{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <div class="d-flex">
        <app-device-crud [deviceId]="device.id" [mode]="CRUD_MODE.read" [deviceType]="deviceTypes"
                         [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>

        <app-device-crud *ngIf="!devicesMultiLevel" [deviceId]="device.id" [mode]="CRUD_MODE.update" [deviceType]="deviceTypes"
                         [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>

        <app-device-crud [deviceId]="device.id" [mode]="CRUD_MODE.delete" [deviceType]="deviceTypes"
                         [unitList]="unitList" (deviceLoading)="showSpinner = $event"></app-device-crud>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="extra_action">
    <th mat-header-cell *matHeaderCellDef width="130px">{{'EXTRA_ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let device">
      <app-device-configuration-download [device]="device"></app-device-configuration-download>
      <button *ngIf="isSchedulable(device)" type="button"
              class="btn list-tools"
              (click)="openScheduler(device.id)"
              placement="left"
              [ngbTooltip]="'OPEN_SCHEDULER_TOOLTIP' | translate">
        <fa-icon [icon]="iconService.faClock"></fa-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator #matPaginatorDevice [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
               [pageSize]="pageSize"></mat-paginator>
